import * as angular from "angular";
import {IController, IScope} from "angular";

export class selfPickupsTableRowCtrl implements IController {

  selfPickup: any;
  selfPickupId: string;
  isSelected: boolean;

  /* @ngInject */
  constructor(private $selfPickups, private $scope: IScope) {
  }

  $onInit() {
    if (this.selfPickupId) {
      this.$selfPickups(this.selfPickupId).$bindCtrlToId(this.$scope, this, 'selfPickup', 'selfPickupId');
    }
  };

  $onChanges(changes) {
    if (changes.selfPickupId && !changes.selfPickupId.isFirstChange()) {
      this.$onInit();
    }
  };

}

angular
  .module('bringoz.admin.self-pickups')
  .component('selfPickupsTableRow', {
    require: {
      selfPickupsTableCtrl: '^selfPickupsTable'
    },
    bindings: {
      selfPickup: '<',
      selfPickupId: '<',
      isSelected: '<'
    },
    template: require('./self-pickups-table-row.html').default,
    controller: selfPickupsTableRowCtrl
  });
